import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

interface IProps {
  npiIsRequired: boolean;
}

export const validationSchema = ({ npiIsRequired }: IProps) =>
  createValidationSchema({
    invoiceTerms: commonValidationSchemas.string({ required: true }),
    invoiceFolder: commonValidationSchemas.string({ required: true }),
    customerTypeGuid: commonValidationSchemas.string({ required: true }),
    invoiceNPI: commonValidationSchemas.string({ required: npiIsRequired }),
  });
